import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'readableDate',
    pure: true,
    standalone: true
})
export class ReadableDatePipe implements PipeTransform {

  transform(value: Date | string | number | null | undefined, dateOnly: boolean = false): string {
    if (value === null || value === undefined) {
      return '-';
    }
    if (typeof value === 'string' && value.trim() === '') {
      return '-';
    }

    // Normalize date-only strings to an explicit local midnight:
    //  - 'MM-DD-YYYY' is not parsed at all by Safari, so it is reordered first
    //  - bare 'YYYY-MM-DD' is parsed as UTC midnight by the Date constructor, which
    //    renders as the *previous* day in every negative-offset timezone
    let normalized: Date | string | number = value;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      const yearLast = /^(\d{2})-(\d{2})-(\d{4})$/.exec(trimmed);
      if (yearLast) {
        const [, mm, dd, yyyy] = yearLast;
        normalized = `${yyyy}-${mm}-${dd}T00:00:00`;
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        normalized = `${trimmed}T00:00:00`;
      }
    }

    const date = new Date(normalized);
    if (isNaN(date.getTime())) {
      return '-';
    }

    const day = date.getDate();
    const paddedDay = day.toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    const hours12 = date.getHours() % 12 || 12;
    const paddedHours = hours12.toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

    const suffix = this.getDaySuffix(day);

    if (dateOnly) {
      return `${month} ${paddedDay}${suffix}, ${year}`;
    }

    return `${month} ${paddedDay}${suffix}, ${year} ${paddedHours}:${minutes}:${seconds} ${ampm}`;
  }

  private getDaySuffix(day: number): string {
    if (day >= 11 && day <= 13) {
      return 'th';
    }

    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
}
